import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

const KEY = "revitalize.auth";
const listeners = new Set();
let state = (() => { try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; } })();
let prompt = { open: false, reason: "", resume: null, key: null };
const RESUME = "revitalize.resume";

const emit = () => listeners.forEach((l) => l());
const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };

export const getAuth = () => state;
export const useAuth = () => useSyncExternalStore(subscribe, () => state);
export const usePrompt = () => useSyncExternalStore(subscribe, () => prompt);

export function setSession(data) {
  state = { accessToken: data.accessToken, user: data.user };
  localStorage.setItem(KEY, JSON.stringify(state));
  localStorage.setItem("revitalize.guest", JSON.stringify(data.guest));
  emit();
}

export function signOut() {
  state = null;
  localStorage.removeItem(KEY);
  localStorage.removeItem("revitalize.guest");
  emit();
}

export function requireAuth(reason, resume, key = null) {
  if (state) return resume?.();
  prompt = { open: true, reason, resume, key };
  emit();
}

export function closePrompt(success) {
  const fn = success ? prompt.resume : null;
  prompt = { open: false, reason: "", resume: null, key: null };
  emit();
  if (fn) setTimeout(fn, 50);
}

api.interceptors.request.use((cfg) => {
  if (state?.accessToken) cfg.headers.Authorization = `Bearer ${state.accessToken}`;
  return cfg;
});

api.interceptors.response.use(undefined, (e) => {
  if (e?.response?.status === 401 && state && !String(e.config?.url).startsWith("/auth/")) signOut();
  return Promise.reject(e);
});

export function startGoogle() {
  sessionStorage.setItem(RESUME, JSON.stringify({ key: prompt.key, path: window.location.pathname }));
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + window.location.pathname;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function takeResume(key) {
  try {
    const r = JSON.parse(sessionStorage.getItem(RESUME));
    if (r?.key && r.key === key) { sessionStorage.removeItem(RESUME); return true; }
  } catch { /* ignore */ }
  return false;
}
